import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { getDomainsTimelineInOverview } from "../../API/api";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
  LabelList,
  ReferenceLine,
  BarChart,
  Cell,
  Bar,
  AreaChart,
  Area
} from "recharts";
import moment from "moment";
import VizHeader from "../VizHeader/VizHeader";
import { Spin } from "antd";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { IconButton } from "@mui/material";
import { useCurrentPng, useGenerateImage } from "recharts-to-png";
import { Tooltip as Tooltip2 } from "@mui/material";
import FileSaver, { saveAs } from "file-saver";
import { Dropdown } from "antd"
import SelectComponentForQuestionsSubmitted from '../../Component/SelectMonthsDurationCMGraphs/SelectComponentForQuestionsSubmitted'
import * as htmlToImage from 'html-to-image';
import SelectComp from "../../NewComponent/Select/Select";
import ChartToggleComponent from "../../NewComponent/ChartToggleComponent/ChartToggleComponent";
import { toggleChartRegionValues } from "../../utils";
import { ReactComponent as SettingIcon } from "./../../Icons/settings.svg";




export default function LineChartComponent() {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const cmRootReducer = useSelector((state) => state.cmRoot);
  const overviewReducer = useSelector((state) => state.cmOverview);
  const [domains, setDomains] = React.useState([]);
  const { getDomainsTimelineData } = bindActionCreators(Actions, dispatch);
  const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
  const [domainsCountArray, setDomainsCountArray] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [getLinePng, { ref: lineRef }] = useCurrentPng();
  const [getRegionData, setRegionData] = React.useState([])
  const [getRegionKeys, setRegionKeys] = React.useState([])
  // const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndex, setActiveIndexIn] = React.useState(0);
  const [getTooltipPayload, setTooltipPayload] = React.useState([]);
  const [activeKeys, setActiveKeys] = React.useState([])
  const [legendClicked, setLegendClicked] = React.useState(false);
  const [getLegendName, setLegendName] = React.useState([])
  // const[getLegendName, setLegendName] = React.useState("")
  const [getRegions, setRegions] = React.useState([])
  const [activeKey, setActiveKey] = React.useState(null)
  const [activeKeyRegion, setActiveKeyRegion] = React.useState(null)
  const [activeChartType, setActiveChartType] = React.useState({ id: 1, type: 'line' })
  const [dropdownToggle, setDropdownToggle] = React.useState(false)

  const dropdownRef = React.useRef(null);
  const selectRef = React.useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!dropdownRef.current) return;

      const isClickInsideDropdown = dropdownRef.current.contains(event.target);

      let isClickInsideSelectDropdown = false;
      let node = event.target;
      while (node) {
        if (node.classList && node.classList.contains('ant-select-dropdown')) {
          isClickInsideSelectDropdown = true;
          break;
        }
        node = node.parentNode;
      }

      if (!isClickInsideDropdown && !isClickInsideSelectDropdown) {
        setDropdownToggle(false);
      }
    };

    if (dropdownToggle) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownToggle]);



  const onClickChangeChartType = (value) => {
    setActiveChartType(value)
  }

  const handleMouseEnterRegion = (data, index) => {
    setActiveIndexIn(index);
  };

  const handleMouseLeave = () => {
    setActiveIndexIn(null);
    setTooltipPayload([])
  };

  // const handleAreaDownload = React.useCallback(async () => {
  //   const png = await getLinePng();
  //   if (png) {
  //     FileSaver.saveAs(png, "line-chart.png");
  //   }
  // }, [getLinePng]);

  const handleAreaDownload = () => {
    htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[1], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
      .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = `questions-submitted-to-experts.png`
        link.href = dataUrl;
        link.click();
      });
  }

  const handleLegendClick = (e, name) => {
    // const { obj } = e;


    const isActive = activeKeys.includes(name);

    setActiveKeys((prevActiveKeys) =>
      isActive ? prevActiveKeys.filter((key) => key !== name) : [...prevActiveKeys, name]
    );
    // setLegendName((prev)=>[new Set(...prev,name)])
    // setLegendName(name)

    setLegendName(prevClickedDomains => {
      if (prevClickedDomains.includes(name)) {
        // If the domain name is already in the list, remove it
        const updatedList = prevClickedDomains.filter(domain => domain !== name); prevClickedDomains.filter(name => name !== name);
        return updatedList;
      } else {
        // Otherwise, add the domain name to the list
        return [...prevClickedDomains, name];
      }
    });
  };

  useEffect(() => {
    if (cmRootReducer.selecetdRoutingValue !== "") {
      setLoading(true);
      getDomainsTimelineInOverview(
        expertOverview.durationQ.value,
        cmRootReducer.selecetdRoutingValue,
        cmRootReducer.selectedGeoLevel.length === 0
          ? ""
          : cmRootReducer.selectedGeoLevel.label,
        cmRootReducer.selectedDomainIds,
        overviewReducer.userTypeSelect.value
      ).then((res) => {
        if (res === undefined) return;
        if (res.data.data !== undefined || res.data.success) {
          setLoading(false);
          const newArray = Object.entries(res.data.data)
            .sort()
            .map(([date, obj]) => ({ date, ...obj }));
          function getValuesForGeoLevels(val) {
            if (cmRootReducer.selecetdRoutingValue === 1) {
              val = cmRootReducer.selectedGeoLevel.label;
              return val;
            }
            if (cmRootReducer.selecetdRoutingValue === 2) {
              //   let data = res.data.data
              //   let dateKeys = Object.entries(res.data.data).map(([date,value])=>{return {date:date,...value}})
              //   console.log(dateKeys,'check date keys')
              //   let newDateKeys = Object.values(res.data.data);
              //   let mappedCountries = newDateKeys.map((ob=>{return Object.keys(ob)}))
              //   console.log(mappedCountries, 'check mapped countries')
              //   let uniqueCountries = [mappedCountries[0]]
              //   setRegionKeys(uniqueCountries)
              //   console.log(getRegionKeys,'check region keys')
              // let countrySpecificData = dateKeys.map((o,i)=>{
              //   delete o.date;
              //   let obj1 = {[o]:Object.values(o).reduce((a,b)=>a+b,0)}
              //   return obj1;
              // })
              //   let newDataArray = [];
              //   let newArray = [];
              //   newArray = Object.entries(data).map(([date,value])=>{return {date:date,countries:Object.keys(value),keys:Object.entries(value).map(([name,value])=>{return {[name]:Object.values(value).reduce((a,b)=>a+b,0)}}),
              //   Total:Object.values(value).reduce((r, o) => (
              //     Object.entries(o).forEach(([k, v]) => (r[k] = (r[k] || 0) + v)), r
              //   ),
              //   {}),domains:Object.keys(value).map((ob)=>value[ob]),...value}})
              //   let newArray2 = newArray.map((obj,i)=>
              //   {
              //     let key='';
              //     obj.countries.map((o)=>{
              //       key = o;
              //       return key;
              //     })
              //     console.log(key,'check key')
              //     return { date:obj.date,countries:obj.countries,keys:obj.keys,Total:Object.values(obj.Total).reduce((a,b)=>a+b,0),domains:obj.domains }
              //   })
              //   console.log(newArray,'check new array domains')
              //   console.log(newArray2,'check new array 2')
              // setRegionData(newArray2)
              const formatData = (objj) => {
                let dates = Object.keys(objj).sort();
                let newArr = [];
                dates.filter((obj, index) => {
                  newArr.push({ date: obj });
                  Object.keys(objj[obj]).filter(ct => {
                    newArr[index] = { countries: Object.keys(objj[obj]), [`${ct}Domains`]: Object.entries(objj[obj][ct]).map(([name, value]) => { return { [name]: value } }), ...newArr[index], [ct]: Object.values(objj[obj][ct]).reduce((a, b) => a + b, 0) };
                  })
                })
                setRegionData(newArr)
                return newArr
              }
              formatData(res.data.data)
              setRegionKeys(Object.values(res.data.data).map((ob) => { return Object.keys(ob) }))
              setRegions(Object.values(res.data.data).map((ob) => { return Object.keys(ob) })[0])
            }
            if (cmRootReducer.selecetdRoutingValue === 3) {
              val = "Global";
              return val;
            }
          }
          let newArray1 = newArray.map((obj, ind) => {
            return {
              date: moment(obj.date).format("MMM DD, YYYY"),
              ...obj[getValuesForGeoLevels("Global")],
            };
          });
          getDomainsTimelineData(newArray1);
          setActiveKeys(Object.keys(newArray1[0]).splice(1))
          // let newArray2 = newArray1.map((ob,ind)=>{
          // 	return Object.values(ob)
          // })
          var result = newArray1.reduce(
            (r, o) => (
              Object.entries(o).forEach(([k, v]) => (r[k] = (r[k] || 0) + v)), r
            ),
            {}
          );
          // getDomainsTimelineData(newArray1);
          setDomainsCountArray(
            Object.entries(result).map(([name, totalCount]) => {
              return { name: name, totalCount: totalCount };
            })
          );
          // let filteredArray = domainsCountArray.filter((obj)=>{
          //   if(obj.totalCount > 0)
          //   {
          //     return obj
          //   }
          // })
          // setDomainsCountArray(filteredArray)
          // getDomainsTimelineData(filteredArray)
          // console.log(filteredArray,'check if filtered array is correct')
        }
      });
    }
  }, [
    expertOverview.durationQ,
    cmRootReducer.selecetdRoutingValue,
    cmRootReducer.selectedGeoLevel.length !== 0 &&
    cmRootReducer.selectedGeoLevel.label,
    cmRootReducer.selectedDomainIds,
    cmRootReducer.selectedGeoLevel.label,
    cmRootReducer.selectedDomainIds,
    overviewReducer.userTypeSelect,
  ]);

  const renderDynamicData = () => {
    return (
      <>
        {expertOverview.getDomainsByTimeline.map((obj, ind) => {
          obj.Global.map((ob, i) => {
            return (
              <Line
                stroke="orange"
                key={obj.date}
                name={ob.name}
                dataKey="value"
                data={obj.Global}
                type="monotone"
                strokeWidth={2}
              />
            );
          });
        })}
      </>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {

      return (
        // <div className="custom-tooltip" style={{ border: '1px solid #ccc',
        // backgroundColor: '#fff',padding:'5px',}}>
        //    <p className="label">{`${label}`}</p>
        //   {/* <p className="intro" style={{fontWeight:600}}>{payload[0].name}:{payload[0].value}</p>  */}
        //     {
        //       payload[0].payload.countries.map((ob)=>{
        //         return <p className="label" >{ob}:{payload[0].payload[ob]}</p>
        //       })
        //     }
        //   {
        //     payload[0].payload.countries.map((ob) => {
        //       return (
        //         <>
        //           <p className="label">Domains In{" "}{ob}:</p>
        //           {payload[0].payload[`${ob}Domains`].map((obj,ind)=>{
        //             return (Object.keys(obj).map((name)=>{
        //               console.log(name,obj,'check name')
        //               return <p className="label" style={{fontWeight:'normal'}} key={name}>{name}:{" "}{obj[name]}</p>
        //             }))
        //           }                     
        //           )}
        //         </>
        //       )
        //     })
        //   }     
        // </div>
        <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', boxShadow: `0 3px 10px rgb(0 0 0 / 0.3)`, border: `1px solid ${getTooltipPayload.length > 0 && getTooltipPayload[0]?.fill}` }}>
          {getTooltipPayload.length === 0 && (
            <>
              <p className="label">{moment(label).format('MMM DD, YYYY')}</p>
            </>
          )}
          {
            getTooltipPayload.length > 0 && getTooltipPayload.map((obj, ind) => {
              return (
                <>
                  <p className="label">{moment(obj.payload.date).format('MMM DD, YYYY')}</p>
                  {/* <p className="label">Total:{obj.payload.countries.map((o,i)=>{return <p>{obj.payload[o]}</p>})}</p> */}
                  {obj.value > 0 && <p className="label" style={{ fontWeight: 500 }}>{obj.dataKey}:{" "}{obj.value}</p>}
                  <p className="label">Domains:</p>
                  {obj?.payload[`${obj.dataKey}Domains`]?.map((dom, ind) => {
                    return (
                      Object.keys(dom).map((name) => {
                        return dom[name] > 0 && <p className="label" style={{ fontWeight: 500 }} key={name}>{name}:{" "}{dom[name].toLocaleString()}</p>
                      })
                    )
                  })}
                </>
              )
            })
          }
        </div>
      );
    }

    return null;
  };

  const handleMouseEnterLegend = (e, data) => {
    setActiveKey(data)
  }

  const handleMouseEnterLegendRegion = (data) => {
    setActiveKeyRegion(data.dataKey)
  }

  const handleMouseOutRegion = () => {
    setActiveKeyRegion(null)
  }

  const handleMouseOutLegend = () => {
    setActiveKey(null)
  }

  const renderLegend = (props) => {
    const { payload } = props;
    if (payload.length > 0) {
      return (
        <div
          style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
        >
          {domainsCountArray.length > 0 &&
            domainsCountArray.slice(1).map((obj, ind) => {
              if (obj.totalCount !== 0) {
                return (
                  <div
                    onMouseEnter={(e) => handleMouseEnterLegend(e, obj.name)}
                    onMouseLeave={() => handleMouseOutLegend()}
                    onClick={(e) => handleLegendClick(e, obj.name)}
                    className="recharts-legend-item"
                    key={ind}
                    style={{
                      color: COLORS[ind % COLORS.length],
                      paddingRight: "10px",
                      fontWeight: "bold",
                      // opacity:(getLegendName === obj.name && legendClicked) ? 0.2 : 1
                      // opacity:(getLegendName.includes(obj.name[ind])) ? 0.2 : 1
                      // opacity:(getLegendName.includes(obj.name)) ? 0.2 : 1
                      opacity: getLegendName.includes(obj.name) ? 0.6 : 1
                    }}
                  >
                    {obj.name} ({obj.totalCount})
                  </div>
                );
              }
            })}
        </div>
      );
    }
  };

  const COLORS = [
    // "#7cb5ec",
    // "#434348",
    // "#90ed7d",
    // "#f7a35c",
    // "#8085e9",
    // "#f15c80",
    // "#e4d354",
    // "#2b908f",
    // "#f45b5b",
    // "#91e8e1",
    "#009BFF",
    "#00B8E6",
    "#B85CFF",
    "#5E3BFF",
    "#F4C900",
    "#EF7928",
    "#00C16E",
  ];

  const renderLabelValue = (val) => {
    if (val === null) {
      return "Last Month (UTC Timezone)";
    }
    if (val === "3months") {
      return "Last 3 months";
    }
    if (val === "6months") {
      return "Last 6 months";
    }
    if (val === "12months") {
      return "Last 12 months";
    }
    if (val === "-1months") {
      return "Year-To-Date";
    }
  };

  const handleMouseEnter = (useCallback((data, index) => {
    setActiveIndexIn(index);
    setTooltipPayload(data?.tooltipPayload);
  }, []));

  const handleDownloadJPEG = () => {
    const chartContainer = document.getElementsByClassName("recharts-wrapper")[1];
    if (!chartContainer) return;

    const chartSvg = chartContainer.querySelector("svg");
    if (!chartSvg) return;

    const svgData = new XMLSerializer().serializeToString(chartSvg);
    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = chartSvg.clientWidth;
      canvas.height = chartSvg.clientHeight;
      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(img, 0, 0);

      canvas.toBlob((blob) => {
        if (blob) {
          saveAs(blob, "question-submitted-to-experts.jpeg");
        }
        URL.revokeObjectURL(url);
      }, "image/jpeg");
    };

    img.onerror = (err) => {
      URL.revokeObjectURL(url);
    };

    img.src = url;
  };


  function downloadSvgAsJpeg() {
    htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[1], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
      .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = 'question-submitted-to-experts.jpeg';
        link.href = dataUrl;
        link.click();
      });

  }

  const handleDownloadSVG = () => {
    const chartContainer =
      document.getElementsByClassName("recharts-wrapper")[1];
    const chartSvg = chartContainer.querySelector("svg");
    const chartXml = new XMLSerializer().serializeToString(chartSvg);
    const svgBlob = new Blob([chartXml], {
      type: "image/svg+xml;charset=utf-8",
    });
    saveAs(svgBlob, "question-submitted-to-experts.svg");
  };

  const items = [
    {
      key: "1",
      label: (
        // <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
        //   1st menu item
        // </a>
        <div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
      ),
    },
    {
      key: "4",
      label: (
        <div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
      ),
    },
  ];

  const renderKey = (data) => {
    // console.log(data, 'check data coming in')
  }

  const CustomizedContentForRegionAndGlobal = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {
      let filteredPayload = payload.filter((obj) => {
        if (obj.value > 0) {
          return obj
        }
      })
      if (filteredPayload.length > 0) {
        return (
          <p className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ececec', padding: '5px' }}>
            <p className="label" style={{ marginLeft: '7px' }}>{payload[0].payload.date}{" "}</p>
            {filteredPayload.map((obj) => {
              return (
                <>
                  <p className="label" style={{ margin: '7px', color: obj.color }}>{obj.dataKey}:{" "}{obj.value.toLocaleString()}</p>
                </>
              )
            })}
          </p>
        )
      }
      if (filteredPayload.length === 0) {
        return (
          <p className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ececec', padding: '5px' }}>
            <p className="label">{payload[0].payload.date}</p>
          </p>
        )
      }

    }
  }

  const CustomTooltipForBarGraph = ({ payload, active, label }) => {
    if (active) {
      return (
        <div className="custom-tooltip">
          what{label}
        </div>
      )
    }
    return null
  }

  const calculateShadowStyle = (barWidth) => {
    // Adjust shadow based on the width of the bar
    const blurRadius = barWidth / 4; // Adjust blur according to bar width
    const shadowColor = 'rgba(0, 0, 0, 0.3)'; // Define shadow color and transparency
    const shadowOffsetX = barWidth / 10; // Adjust shadow offset x based on bar width
    const shadowOffsetY = barWidth / 10; // Adjust shadow offset y based on bar width

    return {
      filter: `drop-shadow(${shadowOffsetX}px ${shadowOffsetY}px ${blurRadius}px ${shadowColor})`,
    };
  };

  const CustomBar = ({ x, y, width, height, fill, ...rest }) => {
    const shadowStyle = calculateShadowStyle(width);
    return (
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        style={shadowStyle}
        {...rest}
      />
    );
  };

  const handleLegendClickRegion = (e) => {
    const { dataKey } = e;

    const isActive = getRegions.includes(dataKey);

    // If active, remove it from activeKeys; if not active, add it
    setRegions((prevActiveKeys) =>
      isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
    );
  }

  return (
    <>
      <div style={{ position: 'relative', padding: '10px', backgroundColor: '#fff', borderRadius: '8px' }}>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '5px' }}>
          <div style={{ width: '30%' }} />
          <div style={{ width: '40%', textAlign: 'center' }}>
            <VizHeader type={4} isBold={true}>Questions Submitted To Experts</VizHeader>
          </div>
          <div style={{ width: '30%', display: 'flex', paddingRight: '12px', justifyContent: 'flex-end' }}>
            <SettingIcon style={{ fontSize: '24px', cursor: 'pointer', }} onClick={() => setDropdownToggle(!dropdownToggle)} />

          </div>
        </div>



        <Spin spinning={loading}>
          {/* LINE CHART */}
          {(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && activeChartType.id === 1 && (
            <ResponsiveContainer width={"100%"} minHeight={400}>
              <LineChart
                data={expertOverview.getDomainsByTimeline}
                margin={{ top: 5, right: 40, left: 30, bottom: 5 }}
                ref={lineRef}
              >
                <CartesianGrid stroke="#ececec" vertical={false} />
                <XAxis
                  dataKey="date"
                  angle={-45}
                  tickFormatter={(value) => moment(value).format("MMM-DD")}
                  fontSize={11}
                  interval={"equidistantPreserveStart"}
                  dy={9}
                  dx={5}
                  offset={7}
                >
                  <Label fontSize={12} fontWeight={"bold"} dy={30} value={renderLabelValue(expertOverview.durationQ.value)} />
                </XAxis>
                <YAxis
                  refY={"left"}
                  style={{ fontSize: "12px" }}
                  axisLine={false}
                  tickLine={false}
                  allowDecimals={false}
                >
                  <Label value="No of Questions" fontWeight={"bold"} dx={-20} angle={-90} />
                </YAxis>
                <Tooltip
                  wrapperStyle={{ fontSize: "12px", fontWeight: "bold" }}
                  cursor={false}
                  content={<CustomizedContentForRegionAndGlobal />}
                />
                <Legend
                  wrapperStyle={{
                    fontSize: "12px",
                    padding: "12px",
                    textAlign: "center",
                    bottom: -3,
                    cursor: 'pointer',
                  }}
                  content={renderLegend}
                  onClick={handleLegendClick}
                />
                {domainsCountArray.slice(1).map((ob, ind) => (
                  <Line
                    dataKey={ob.name}
                    strokeWidth={1.5}
                    // strokeWidth={key === 'Submitted' ? 2.5 : 1.5}
                    key={ind}
                    stroke={COLORS[ind % COLORS.length]}
                    type="bumpX"
                    hide={getLegendName.includes(ob.name)}
                    opacity={activeKey === ob.name || activeKey === null ? 1 : 0.2}
                    dot={false}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
          )}

          {/* BAR CHART */}
          {activeChartType.id === 2 && (cmRootReducer.selecetdRoutingValue === 1 || cmRootReducer.selecetdRoutingValue === 3) && (
            <ResponsiveContainer width={'100%'} height={400}>
              <BarChart
                data={expertOverview.getDomainsByTimeline}
                margin={{ top: 5, right: 40, left: 30, bottom: 5 }}
                ref={lineRef}
              >
                <CartesianGrid stroke="#ececec" vertical={false} />
                <XAxis
                  dataKey="date"
                  angle={-45}
                  tickFormatter={(value) => moment(value).format("MMM-DD")}
                  fontSize={11}
                  interval={"equidistantPreserveStart"}
                  dy={9}
                  dx={5}
                  offset={7}
                >
                  <Label fontSize={12} fontWeight={"bold"} dy={30} value={renderLabelValue(expertOverview.durationQ.value)} />
                </XAxis>
                <YAxis
                  refY={"left"}
                  style={{ fontSize: "12px" }}
                  axisLine={false}
                  tickLine={false}
                  allowDecimals={false}
                >
                  <Label value="No of Questions" fontWeight={"bold"} dx={-20} angle={-90} />
                </YAxis>
                <Legend
                  wrapperStyle={{
                    fontSize: "12px",
                    padding: "12px",
                    textAlign: "center",
                    bottom: -3,
                    cursor: 'pointer',
                  }}
                  content={renderLegend}
                  onClick={handleLegendClick}
                />
                <Tooltip
                  wrapperStyle={{ fontSize: "12px", fontWeight: "bold" }}
                  cursor={false}
                />
                {domainsCountArray.slice(1).map((ob, ind) => (
                  <Bar
                    dataKey={ob.name}
                    key={ind}
                    fill={COLORS[ind % COLORS.length]}
                    hide={getLegendName.includes(ob.name)}
                    opacity={activeKey === ob.name || activeKey === null ? 1 : 0.2}
                    stackId="a"
                  />
                ))}
              </BarChart>
            </ResponsiveContainer>
          )}

          {/* REGION CHART */}
          {cmRootReducer.selecetdRoutingValue === 2 && (
            <ResponsiveContainer width={'100%'} height={400}>
              <BarChart
                data={getRegionData}
                margin={{ top: 20, right: 20, left: 20, bottom: 10 }}
                barSize={20}
                stackOffset="sign"
                ref={lineRef}
              >
                <CartesianGrid vertical={false} stroke="#ececec" />
                <XAxis
                  dataKey="date"
                  angle={-45}
                  interval={"equidistantPreserveStart"}
                  offset={7}
                  dy={10}
                  dx={2}
                  tickMargin={5}
                  fontSize={12}
                  tickFormatter={(value) => moment(value).format("MMM-DD")}
                >
                  <Label fontSize={12} fontWeight={"bold"} dy={32} value={renderLabelValue(expertOverview.durationQ.value)} />
                </XAxis>
                <YAxis fontSize={12} axisLine={false} tickLine={false}>
                  <Label value="No of Questions" fontWeight={"bold"} dx={-20} angle={-90} />
                </YAxis>
                <Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} cursor={{ fill: 'transparent' }} content={<CustomTooltip />} />
                <Legend
                  onMouseOver={handleMouseEnterLegendRegion}
                  onMouseLeave={handleMouseOutRegion}
                  wrapperStyle={{ fontSize: '12px', fontWeight: 'bold', padding: '10px', bottom: -5, cursor: 'pointer' }}
                  onClick={handleLegendClickRegion}
                />
                {getRegionKeys[0]?.map((o, ind) => (
                  <Bar
                    key={o}
                    hide={!getRegions.includes(o)}
                    dataKey={o}
                    stackId={"a"}
                    opacity={activeKeyRegion === o || activeKeyRegion === null ? 1 : 0.2}
                    fill={COLORS[ind % COLORS.length]}
                    onMouseOver={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Cell />
                  </Bar>
                ))}
              </BarChart>
            </ResponsiveContainer>
          )}
        </Spin>

        {dropdownToggle && (
          <div
            ref={dropdownRef}
            style={{
              position: 'absolute',
              top: '50px',
              right: '10px',
              width: '240px',
              backgroundColor: '#fff',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              zIndex: 10
            }}>
            <div style={{ textAlign: 'end' }}>
              <i
                onClick={() => setDropdownToggle(false)}
                className="fa fa-close"
                style={{ fontSize: '18px', cursor: 'pointer' }}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {/* <i className="fa fa-gear" style={{ fontSize: '24px', cursor: 'pointer' }} onClick={() => setDropdownToggle(false)} /> */}
            </div>
            <div ref={selectRef} style={{paddingBottom:"8px"}}>
            
              <SelectComponentForQuestionsSubmitted />
            </div>

            {toggleChartRegionValues(cmRootReducer.selecetdRoutingValue) && (
              <div style={{ textAlign: 'end' }}>
                <ChartToggleComponent onClickFunction={() => onClickChangeChartType({ id: 1, type: 'line' })} fontSize={'24px'} type={'line'} value={activeChartType} />
                &nbsp;&nbsp;&nbsp;
                <ChartToggleComponent type={'bar'} value={activeChartType} fontSize={'24px'} onClickFunction={() => onClickChangeChartType({ id: 2, type: 'bar' })} />
              </div>
            )}
            <div style={{ paddingTop: '15px', paddingBottom: '15px', textAlign: 'end' }}>
              <span style={{ fontSize: '14px', color: '#5c667b', fontFamily: 'Inter' }}>Download PNG</span>{" "}
              <span onClick={handleAreaDownload} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}>
                <i className="fa fa-download" style={{ fontSize: '16px' }} />
              </span>
            </div>
            <div style={{ paddingBottom: '15px', textAlign: 'end' }}>
              <span style={{ fontSize: '14px', color: '#5c667b', fontFamily: 'Inter' }}>Download JPEG</span>{" "}
              <span onClick={handleDownloadJPEG} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}>
                <i className="fa fa-download" style={{ fontSize: '16px' }} />
              </span>
            </div>
            <div style={{ paddingBottom: '15px', textAlign: 'end' }}>
              <span style={{ fontSize: '14px', color: '#5c667b', fontFamily: 'Inter' }}>Download SVG</span>{" "}
              <span onClick={handleDownloadSVG} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}>
                <i className="fa fa-download" style={{ fontSize: '16px' }} />
              </span>
            </div>
          </div>
        )}
      </div>
    </>

  );
}
